import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class HomePageInitParamsResolver {
  constructor() {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (route.fragment?.length) {
      const fragments = JSON.parse(
        '{"' + route.fragment.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
        function (key, value) {
          return key === '' ? value : decodeURIComponent(value);
        },
      );
      if (fragments.access_token) {
        const bc = new BroadcastChannel('azure-auth-popup-channel');
        bc.postMessage(fragments.access_token);
        bc.close();
      }
    }
  }
}
